import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { I18nextProvider } from 'react-i18next'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
// import { init as SentryInit, BrowserTracing } from '@sentry/react'
import { WrappedApp } from './App'
import i18next from './i18next'
import { queryClient } from './api'

// development or production
// const { MODE, VITE_SENTRY_DNS } = import.meta.env

/* Sentry disabled for performance reasons
 *
 * Setup Sentry for errors reporting in production
SentryInit({
  dsn: VITE_SENTRY_DNS,
  tracePropagationTargets: ['localhost', 'numisdeal', /^\//],
  integrations: [new BrowserTracing()],
  environment: MODE,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: MODE === 'development' ? 0 : 0.5,
  beforeSend(event) {
    return MODE === 'development' ? null : event
  },
})
*/

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18next}>
        <WrappedApp />
      </I18nextProvider>
      {/* <ReactQueryDevtools /> */}
    </QueryClientProvider>
    <ToastContainer
      position="bottom-left"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  </React.StrictMode>
)
